import { render, staticRenderFns } from "./keyword.vue?vue&type=template&id=3b7f3e1b&scoped=true&"
import script from "./keyword.vue?vue&type=script&lang=js&"
export * from "./keyword.vue?vue&type=script&lang=js&"
import style0 from "./keyword.vue?vue&type=style&index=0&id=3b7f3e1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7f3e1b",
  null
  
)

export default component.exports